export default __webpack_public_path__ + "static/media/girlReading.8f0b12c2.png";